var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0003 18.3334C14.6027 18.3334 18.3337 14.6025 18.3337 10.0001C18.3337 5.39771 14.6027 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001C1.66699 14.6025 5.39795 18.3334 10.0003 18.3334Z","stroke":"#404357","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10 13.3333V10","stroke":"#404357","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10 6.66675H10.0083","stroke":"#404357","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

InfoIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
